import { useContext } from "react";
import { ActivitiesContext } from "../../context/activities-context";
import { addFourteenMaxString, addSevenMaxString, addThirtyMaxString, saturdayMinString, sundayMaxString, todayMaxString, todayMinString } from "./DateFilterdata";

const DateFilter = () => {
	const {
		dateButtonId,
		setDateButtonId,
		dateButtonActive,
		setDateButtonActive,
		setDateString,
		dictionaryWords,
	} = useContext(ActivitiesContext);

	

	const dateFilterHandler = (event) => {
		if (dateButtonId === "") {
			setDateString(event.target.value);
			setDateButtonId(event.target.id);
			setDateButtonActive(true);
		} else if (dateButtonId !== event.target.id) {
			setDateString(event.target.value);
			setDateButtonId(event.target.id);
			setDateButtonActive(true);
		} else if (dateButtonId === event.target.id) {
			setDateString("");
			setDateButtonId("all");
			setDateButtonActive(false);
		}
	};

	return (
		<div className="filter-section">
			<h3>{dictionaryWords.when}</h3>
			<div>
				<button
					id="today"
					value={`&dateFrom=${todayMinString}&dateTo=${todayMaxString}`}
					onClick={dateFilterHandler}
					className={
						dateButtonActive && dateButtonId === "today"
							? "active"
							: ""
					}
				>
					{dictionaryWords.today}
					<i className="fa fa-close"></i>
				</button>
				<button
					id="weekend"
					value={`&dateFrom=${saturdayMinString}&dateTo=${sundayMaxString}`}
					onClick={dateFilterHandler}
					className={
						dateButtonActive && dateButtonId === "weekend"
							? "active"
							: ""
					}
				>
					{dictionaryWords.thisWeekend}
					<i className="fa fa-close"></i>
				</button>
				<button
					id="seven_days"
					value={`&dateFrom=${todayMinString}&dateTo=${addSevenMaxString}`}
					onClick={dateFilterHandler}
					className={
						dateButtonActive && dateButtonId === "seven_days"
							? "active"
							: ""
					}
				>
					{dictionaryWords.nextSevenDays}
					<i className="fa fa-close"></i>
				</button>
				<button
					id="fourteen_days"
					value={`&dateFrom=${todayMinString}&dateTo=${addFourteenMaxString}`}
					onClick={dateFilterHandler}
					className={
						dateButtonActive && dateButtonId === "fourteen_days"
							? "active"
							: ""
					}
				>
					{dictionaryWords.nextFourteenDays}
					<i className="fa fa-close"></i>
				</button>
				<button
					id="thirty_days"
					value={`&dateFrom=${todayMinString}&dateTo=${addThirtyMaxString}`}
					onClick={dateFilterHandler}
					className={
						dateButtonActive && dateButtonId === "thirty_days"
							? "active"
							: ""
					}
				>
					{dictionaryWords.nextThirtyDays}
					<i className="fa fa-close"></i>
				</button>
			</div>
		</div>
	);
};

export default DateFilter;
